import ButtonBase from '@material-ui/core/ButtonBase';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import tw, { css, styled } from 'twin.macro';

const StyledButton = styled(ButtonBase)`
	${props => css`
		&:focus {
			outline: none;
			opacity: 0.9;
	 	};
		&:disabled { ${tw`bg-grey-F text-grey-7`}}
		${tw`relative flex items-center justify-center`};

		${props.showFocus && css`
			&:focus {
				${tw`bg-grey-A border border-solid border-grey-B text-grey-4 text-light`}
				opacity: 0.9;
			};
		`}
		
		${props.mode === 'primary' && tw`text-light mx-05 rounded-05 px-12 py-03 bg-green-2`}
		${props.mode === 'delete' && tw`text-light mx-05 rounded-05 px-12 py-03 bg-red-0`}
		${props.mode === 'outline' && tw`text-grey-5 mx-05 rounded-05 px-10 py-02 bg-light border-2 border-solid border-green-2`}
		${props.mode === 'common' && tw`bg-grey-F border border-solid border-grey-B text-grey-4`}
		
		${props.mode === 'filter' && tw`w-70 rounded-05 px-10 py-02 bg-light text-grey-7 border border-solid border-grey-7 mx-02`}
		
		${props.size === '6rem' && tw`w-60`}

		${props.size === 'large' && tw`text-12 font-medium rounded-05`}
		${props.mode === 'outline' && props.size === 'large' && tw`py-04 px-28`}
		${props.mode !== 'outline' && props.size === 'large' && tw`py-05 px-30`}

		${props.size === 'medium' && tw`text-09 rounded-05`}
		${props.mode === 'outline' && props.size === 'medium' && tw`py-02 px-09`}
		${props.mode !== 'outline' && props.size === 'medium' && tw`py-03 px-10`}

		${props.size === 'small' && tw`text-08 rounded-05`}
		${props.mode === 'outline' && props.size === 'small' && tw`py-02 px-07`}
		${props.mode !== 'outline' && props.size === 'small' && tw`py-03 px-08`}
		
		${props.size === 'smaller' && tw`text-07 rounded-05`}
		${props.mode === 'outline' && props.size === 'smaller' && tw`py-02 px-04`}
		${props.mode !== 'outline' && props.size === 'smaller' && tw`py-02 px-05`}
		
		${props.size === 'smallest' && tw`text-07 rounded-03 mx-03`}
		${props.mode === 'outline' && props.size === 'smallest' && tw`py-px px-03`}
		${props.mode !== 'outline' && props.size === 'smallest' && tw`py-px px-04`}
	`};
`;


export const Button = ({ loading, showFocus, focusOnMount, mode, size, type, children, onClick, ...props }) => {
	const handleClick = event => {
		!loading && onClick && onClick(event);
	};

	return (
		<StyledButton
			ref={input => focusOnMount && input && input.focus()}
			onClick={handleClick}
			showFocus={showFocus}
			type={type}
			mode={mode}
			size={size}
			{...props}
		>
			{loading && <CircularProgress tw='text-grey-D absolute' size={10} />}
			<div className='w-full' css={[ loading && tw`opacity-0` ]}>{children}</div>
		</StyledButton>
	);
};

Button.defaultProps = {
	mode: 'primary',
	type: 'button',
	onClick: undefined,
};
